class SiteBind
    extends QueryElement<HTMLElement> {

    constructor(element: HTMLElement) {
        super(element, false);

        let type = this.getAttr("data-type");
        let text = this.getHtml();
        
        // Only execute on content
        if (text != null) {

            let content: string | null = null;

            switch(type)
            {
                case "datetime":
                    content = new SiteBindDateTime(this).execute(text);
                    break;
            }

            this.setHtml(content ?? "");
        }
    }
}

type SiteBindDateTimeFormat = 'DateTime' | 'DateTimeShort' | 
    'Date' | 'DateShort' | 'Custom' | 'CustomUTC';

class SiteBindDateTime {
    private readonly _format: SiteBindDateTimeFormat;
    private readonly _customFormat: string;
    
    
    constructor(parent: SiteBind) {
        this._format = parent.getAttr("data-format") as SiteBindDateTimeFormat;
        this._customFormat = parent.getAttr("data-format-custom") as string;
    }

    execute(text: string)
    {
        var queryDate = new QueryDate(new Date(text));

        switch(this._format) {
            case "Date":
                return queryDate.format("dd-mm-yyyy", true);
            case "DateShort":
                return queryDate.format("dd-mm", true);
            case "DateTime":
                return queryDate.format("dd-mm-yyyy HH:MM:ss", false);
            case "DateTimeShort":
                return queryDate.format("dd-mm HH:MM", false);
            case "Custom":
                return queryDate.format(this._customFormat, false);
            case "CustomUTC":
                return queryDate.format(this._customFormat, true);
        }
    }

}